import React, { useEffect } from 'react';
import { FlaskConical } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import '../styles/AmbienteBanner.css';

/**
 * Señalización PERMANENTE del ambiente DEV (visible en todas las pantallas,
 * incluido el login, sin depender del rol). En Producción no renderiza nada.
 * El ambiente lo declara el backend (MIDAS_ENV), no el frontend.
 */
export function etiquetaAmbienteDev(entorno) {
  return entorno === 'SUPABASE_DEV' ? 'SUPABASE · DESARROLLO' : 'LOCAL · DESARROLLO';
}

export default function AmbienteBanner() {
  const { ambiente, systemInfo } = useAuth();
  const esDev = ambiente === 'DEV';

  useEffect(() => {
    if (!esDev) return undefined;
    const original = document.title;
    if (!original.startsWith('[DEV]')) document.title = `[DEV] ${original}`;
    return () => { document.title = original; };
  }, [esDev]);

  if (!esDev) return null;
  return (
    <div className="ambiente-banner" role="status" aria-live="polite">
      <FlaskConical size={14} aria-hidden="true" />
      <strong>{etiquetaAmbienteDev(systemInfo?.environment)}</strong>
      <span>· Ambiente de pruebas con datos ficticios · NO es Producción</span>
    </div>
  );
}
